module.exports = __webpack_public_path__ + "img/f.e357f52a.png";